import { reducerType } from '../../reducers/formMirror';

export function setFormValues(formName, values) {
  return {
    type: `${reducerType}/SET_FORM_VALUES`,
    payload: {
      formName,
      values
    }
  };
}

export function clearFormValues(formName) {
  return {
    type: `${reducerType}/CLEAR_FORM_VALUES`,
    payload: {
      formName
    }
  };
}
